import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

const StatusBar = ({ data = [] }) => {
  const filteredData = data.filter((item) => item.count > 0);

  return (
    <div style={{ width: '100%', margin: '0 auto', padding: '10px' }}>
      <div
        style={{
          background: '#1b2a38',
          borderRadius: '16px',
          padding: '24px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)',
          border: '1px solid #1b2a38',
        }}
      >
        {/* Progress Bar */}
        <div
          style={{
            width: '100%',
            background: '#444',
            borderRadius: '9999px',
            height: '24px',
            overflow: 'hidden',
            display: 'flex',
            boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.5)',
          }}
        >
          {filteredData.map((item, index) => (
            <OverlayTrigger
              key={index}
              placement="top"
              overlay={
                <Tooltip id={`tooltip-${index}`}>
                  <strong>{item.name}</strong>
                  <br />
                  {item.count} stations ({item.value.toFixed(2)}%)
                </Tooltip>
              }
            >
              <div
                style={{
                  width: `${item.value}%`,
                  backgroundColor: item.color,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: '#fff',
                    opacity: 0,
                    transition: 'opacity 0.2s',
                  }}
                ></div>
              </div>
            </OverlayTrigger>
          ))}
        </div>
      </div>
    </div>
  );
};

StatusBar.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      count: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
    })
  ),
};

export default StatusBar;
